import {
  useHFStore,
  useIndicatorStore,
  useLayerStore,
  useLGAStore,
  useWardStore,
  useZoneStore,
} from "@/data/Stores";
import useUtilStore from "@/data/util";
import { LocationLevelEnum, StoreEnum } from "@/enums";
import { IMaybe, ISelect } from "@/types";
import { create, StateCreator } from "zustand";
import { devtools } from "zustand/middleware";

export interface SLState {
  selectedState: IMaybe<string>;
  stateList: IMaybe<ISelect[]>;
  stateName: IMaybe<string>;
}

export interface SLActions {
  setSelectedState: (state: IMaybe<string>) => void;
  setStateList: (stateList: IMaybe<ISelect[]>) => void;
  onStateChange: (id: IMaybe<string>) => void;
}

export const storeCreator: StateCreator<SLState & SLActions> = (set) => ({
  selectedState: null,
  stateList: null,
  stateName: null,
  setSelectedState: (selectedState) => {
    const { stateList } = useStateStore.getState();

    set({
      selectedState,
      stateName:
        (stateList?.find((el) => el?.value === selectedState)
          ?.label as string) ?? null,
    });
  },

  // Set the state list
  setStateList: (stateList) => set({ stateList }),

  // Handle state change
  onStateChange: async (id) => {
    const { idxLoad, setSearchPhcText } = useUtilStore.getState();
    const { loadLocationBoundary } = useLayerStore.getState();
    const { setSelectedZone } = useZoneStore.getState();
    const { setSelectedState } = useStateStore.getState();
    const { setSelectedLga } = useLGAStore.getState();
    const { setSelectedWard } = useWardStore.getState();
    const { setSelectedHF } = useHFStore.getState();
    const { setSelectedIndicator } = useIndicatorStore.getState();

    setSearchPhcText("");

    if (!id) {
      setSelectedZone(null);
      setSelectedState(null);
      setSelectedIndicator([]);
      await idxLoad();
      return;
    }

    setSelectedLga(null);
    setSelectedWard(null);
    setSelectedHF(null);
    setSelectedState(id);
    loadLocationBoundary(id, LocationLevelEnum.STATE);
  },
});

const useStateStore = create<SLState & SLActions>(
  devtools(storeCreator, { name: StoreEnum.SL_STORE }) as StateCreator<
    SLState & SLActions
  >
);

export default useStateStore;
